import { createAsyncIcon } from '../../_factory/createAsyncIcon';

// @ts-ignore
const AsyncPhosphorIconBold = createAsyncIcon(() => import('./PhosphorIconBold'));

export default AsyncPhosphorIconBold;

AsyncPhosphorIconBold.displayName = 'AsyncPhosphorIconBold';
